export const SearchBackground = [
  "./assets/search-images/search-01.jpg",
  "./assets/search-images/search-02.jpg",
  "./assets/search-images/search-03.jpg",
  "./assets/search-images/search-04.jpg",
  "./assets/search-images/search-05.jpg",
  "./assets/search-images/search-06.jpg"
]
